<template>
  <div class="page">
    <h2>🎵 How to Play</h2>
    <p>Songstar is a music quiz game where players take turns choosing a song and everyone else tries to guess it 🎤</p>
    <p>The game consists of multiple rounds, each with a choosing phase and a guessing phase 🔄</p>
    <p>The player with the highest score at the end of the game wins! 🏆</p>
  </div>
</template>

<style scoped>
  .page {
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
  }

  h2 {
    color: var(--color-primary);
    font-size: var(--font-size-lg);
    font-weight: var(--font-weight-strong);
    letter-spacing: 0.05em;
    margin: 0;
    text-transform: uppercase;
  }

  p {
    color: var(--color-text);
    font-size: var(--font-size-sm);
    line-height: 1.5;
    margin: 0;
  }
</style>
